import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=4f1ac1e3&scoped=true&"
import script from "./realTime.vue?vue&type=script&lang=js&"
export * from "./realTime.vue?vue&type=script&lang=js&"
import style0 from "./realTime.vue?vue&type=style&index=0&lang=css&"
import style1 from "./realTime.vue?vue&type=style&index=1&id=4f1ac1e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ac1e3",
  null
  
)

export default component.exports